import { PERMISSIONS, ROLES } from "helpers/permissions";
import { AccessSnapshot, checkAccess } from "helpers/permissions";

const SALDO_EFI_ACCESS = {
  roles: [ROLES.ROLE_USER_FIN, ROLES.ROLE_ADMIN, ROLES.ROLE_MASTER, ROLES.ROLE_USER_GER],
  permissions: [PERMISSIONS.PERMISSION_FINANCEIRO],
} as const;

export function userCanViewSaldoEfi(
  access: AccessSnapshot | null | undefined
): boolean {
  if (!access) return false;
  return checkAccess(access, SALDO_EFI_ACCESS);
}

/** @deprecated Prefer useAccess().canAccess() */
export function userCanViewSaldoEfiByRoles(
  roles: string[] | undefined | null
): boolean {
  return userCanViewSaldoEfi({ roles: roles ?? [], permissions: [] });
}

export { SALDO_EFI_ACCESS };
